<template>
  <div class="container photo px-0 py-0">
    <!-- [Added by E2logy]: Added an Eye icon to view the previous and current images (Opens the dialog box)  -->
    <!-- <v-icon
      v-if="attachments && attachments.length > 0 && thumbnailMainImage"
      class="w-full"
      style="cursor:pointer"
      @click.stop="onClickThumbnail(currentProOrMatId, question.id)"
    >
      mdi-eye
    </v-icon> -->
    <!-- [Modified by E2logy]: the preview shows for a photo already stored on the
    server and for one still waiting in the upload queue. -->
    <v-row v-if="thumbnailMainImage">
      <v-col cols="12" sm="12">
        <div class="d-flex justify-content-end my-1">
          <b-icon
            v-if="isHiddenForBrandPhotosPortal == false"
            class="mx-1"
            :icon="isHiddenForBrandPhotosPortal == true ? `eye` : `eye-slash`"
            font-scale="2"
            size="lg"
          ></b-icon>
          <b-icon
            v-if="isWarningPhotosPortal !== null && isWarningPhotosPortal !== 0"
            class="mx-1"
            icon="exclamation-triangle-fill"
            font-scale="2"
            :variant="isWarningPhotosPortal == true ? `danger` : `success`"
          ></b-icon>
        </div>
        <!-- [Added by E2logy]: non blocking upload status of this photo -->
        <div
          v-if="uploadStatus"
          class="d-flex justify-content-center align-center my-1 photo_upload_status"
        >
          <v-progress-circular
            v-if="uploadStatus === 'uploading'"
            indeterminate
            size="16"
            width="2"
            color="primary"
            class="mr-1"
          ></v-progress-circular>
          <b-icon
            v-else-if="uploadStatus === 'pending'"
            icon="cloud-arrow-up"
            class="mr-1"
          ></b-icon>
          <b-icon
            v-else
            icon="exclamation-triangle-fill"
            variant="danger"
            class="mr-1"
          ></b-icon>
          <span :class="uploadStatus === 'failed' ? 'text-danger' : ''">
            {{ uploadStatusLabel }}
          </span>
          <b-button
            v-if="uploadStatus === 'failed'"
            class="ml-2"
            size="sm"
            variant="outline-danger"
            @click.stop="onClickRetryUpload"
          >
            {{ $t("retry") }}
          </b-button>
        </div>
        <div class="relative my-1 d-flex justify-content-center">
          <img
            class="thumbnail_image"
            :src="thumbnailMainImage"
            alt=""
            @error="onImageError"
            @click="onClickThumbnail(currentProOrMatId, question.id)"
          />

          <!-- [Modified by E2logy]: Open the image picker/camera on click of image thumbnail -->
          <!-- <img
            class="thumbnail_image"
            :src="thumbnailMainImage"
            alt=""
            @error="onImageError"
            @click="onClickUploadAttachment"
          /> -->
        </div>
      </v-col>
    </v-row>
    <!-- [Modified by E2logy]: kept outside the preview row so the dialog can be
    opened right after a capture, before any server attachment exists. -->
    <DialogPhotoDetail
      :ref="`dialogPhotoDetail_${currentProOrMatId}_${question.id}`"
      :worksessionPosBrandId="worksessionPosBrandId"
      :surveyListItem="surveyListItem"
      :component="component"
      :proOrMat="proOrMat"
      :question="question"
      :assignTypes="assignTypes"
      :currentProOrMatId="currentProOrMatId"
      :commentsPhotosPortal="commentsPhotosPortal"
      :punctuationLabel="punctuationLabel"
      :worksessionSurveyPhotosPortal="worksessionSurveyPhotosPortal"
      :attachments="dialogAttachments"
      :hasPendingUpload="queuedPhotoEntries.length > 0"
      :onUploadAttachment="onUploadAttachment"
      :onClickUploadAttachment="onClickUploadAttachment"
      @deleteAttachment="delId => deleteAttachment(delId)"
      @onClickSaveComments="saveData => onClickSaveComments(saveData)"
    />
    <v-row v-show="showUploadControls && !readOnlyInputs && isShowCamera">
      <v-col cols="12" sm="12">
        <gennera-picture-input
          :crop="false"
          class="my-gennera-picture-input"
          :ref="`surveyPhotoInstance_${currentProOrMatId}_${question.id}`"
          size="5"
          width="500"
          accept="image/jpeg,image/png"
          button-class="btn btn-outline-info"
          aspect="Landscape"
          :customStrings="{
            drag: `Selecciona una foto`,
            upload: this.$t('uploading_image'),
            change: this.$t('change'),
            tap: 'toma una foto'
          }"
          @change="onPictureSurveyPhoto"
          :capture="`camera`"
        >
        </gennera-picture-input>
      </v-col>
    </v-row>
    <v-row v-show="showUploadControls">
      <v-col cols="12" sm="12" class="text-center">
        <v-btn
          color="primary"
          dark
          :loading="isSelecting"
          @click="onUploadAttachment"
          v-show="!readOnlyInputs && isShowGallery"
          class="btn_select_images"
        >
          {{ buttonText }}
        </v-btn>
        <input
          ref="uploaderPhotos"
          class="d-none"
          type="file"
          accept=".jpg,.png"
          @change="onFileChanged"
        />
      </v-col>
    </v-row>
    <v-row v-if="worksessionSurveyPhotosPortal">
      <v-col cols="12" sm="12">
        <div class="mt-2">
          <h5 class="text--primary">{{ punctuationLabel }}</h5>
          <div
            class="mt-2 text--primary"
            v-if="commentsPhotosPortal.length > 0"
          >
            <h5 class="text--primary">{{ $t("comments") }}</h5>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <ul>
                  <li
                    :key="`photo_comment_${index}`"
                    v-for="(commentItem, index) in commentsPhotosPortal"
                  >
                    {{ commentItem.label }}: {{ commentItem.text }}
                  </li>
                </ul>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// vue-web-cam demo app -
// https://github.com/VinceG/vue-web-cam/blob/master/demo/src/main.vue
import webCamera from "@/components/webCamera.vue";
import { mapGetters } from "vuex";
import ApiService from "@/services/apiService";
import PhotoQueueService from "@/services/photoQueueService";
import { logError } from "@/utils";
import DialogPhotoDetail from "./photodetails/DialogPhotoDetail.vue";
import GenneraPictureInput from "@/components/GenneraPictureInput.vue";

// [Added by E2logy]: first bytes of a real JPEG and of a real PNG. The browser
// takes the file type from the file name only, so a text file renamed to
// ".jpg" passes the accept filter. The server cannot read such a file and
// refuses it on every upload, so it is stopped when it is selected.
const IMAGE_SIGNATURES = [
  [0xff, 0xd8, 0xff],
  [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]
];

const isRealImageFile = file =>
  new Promise(resolve => {
    if (!file || !file.size || typeof file.slice !== "function") {
      resolve(false);
      return;
    }
    // FileReader also works on older iPads, Blob.arrayBuffer() does not.
    const reader = new FileReader();
    reader.onload = () => {
      const bytes = new Uint8Array(reader.result);
      resolve(
        IMAGE_SIGNATURES.some(signature =>
          signature.every((value, index) => bytes[index] === value)
        )
      );
    };
    reader.onerror = () => resolve(false);
    reader.readAsArrayBuffer(file.slice(0, 8));
  });

// [Added by E2logy]: one object URL per local file. Without this cache a new URL
// was created on every re-render of the thumbnail and never released.
const objectUrlCache = new WeakMap();
const getCachedObjectUrl = blob => {
  if (!blob || typeof blob !== "object") return null;
  if (!objectUrlCache.has(blob)) {
    try {
      objectUrlCache.set(blob, URL.createObjectURL(blob));
    } catch (error) {
      return null;
    }
  }
  return objectUrlCache.get(blob);
};

export default {
  props: [
    "value",
    "worksessionPosBrandId",
    "readOnlyInputs",
    "photoType",
    "attachments",
    "surveyListItem",
    "component",
    "proOrMat",
    "question",
    "assignTypes"
  ],
  data() {
    return {
      isSelecting: false,
      selectedFile: null,
      defaultButtonText: "Select ...",
      newAttachedPhotos: []
    };
  },
  components: {
    webCamera,
    DialogPhotoDetail,
    GenneraPictureInput
  },
  // [Modified by E2logy]: the dialog used to be opened from a watcher on
  // attachments, which also fired when the background upload replaced the local
  // preview with the stored photo, so the dialog reopened on its own. It is now
  // opened only by the two user actions that take a photo.
  watch: {},
  computed: {
    ...mapGetters("myroute", ["deviceInformation"]),
    // [Added by E2logy]: photos of this question that are still on the device
    questionIdentity() {
      return {
        worksessionPosBrandId: this.worksessionPosBrandId,
        surveyId: this.surveyListItem?.id,
        componentId: this.component?.id,
        surveyProOrMatId: this.currentProOrMatId,
        surveyQuestionId: this.question?.id
      };
    },
    queuedPhotoEntries() {
      return PhotoQueueService.entriesForQuestion(this.questionIdentity);
    },
    // Preview of the newest photo still waiting to be sent. This comes from the
    // queue, not from question.attachments, so the photo stays on screen even if
    // the survey data is reloaded.
    pendingPreviewUrl() {
      const entries = this.queuedPhotoEntries;
      if (!entries || entries.length === 0) return null;
      for (let i = entries.length - 1; i >= 0; i--) {
        if (entries[i] && entries[i].previewUrl) return entries[i].previewUrl;
      }
      return null;
    },
    // What the photo dialog shows. When nothing is on the server yet, the photo
    // waiting in the queue is shown instead of an empty slider.
    dialogAttachments() {
      const visible = this.visibleAttachments;
      if (visible && visible.length > 0) return visible;
      if (this.pendingPreviewUrl) {
        return [{ localPreviewUrl: this.pendingPreviewUrl }];
      }
      return visible;
    },
    uploadStatus() {
      const entries = this.queuedPhotoEntries;
      if (!entries || entries.length === 0) return null;
      if (entries.some(el => el.status === "uploading")) return "uploading";
      if (entries.some(el => el.status === "failed")) return "failed";
      return "pending";
    },
    uploadStatusLabel() {
      if (this.uploadStatus === "uploading") return this.$t("photo_uploading");
      if (this.uploadStatus === "failed") return this.$t("photo_upload_failed");
      if (this.uploadStatus === "pending")
        return this.$t("photo_saved_on_device");
      return "";
    },
    visibleAttachments() {
      const current = Array.isArray(this.attachments) ? this.attachments : [];
      const lastResponse =
        this.question?.foundLastResponseSurveyQuestionItem
          ?.worksession_survey_response_attachments || [];
      if (!current.length || !lastResponse.length) return current;

      const lastIds = new Set(
        lastResponse
          .map(el => (el && (el.id || el.photoId) ? el.id || el.photoId : null))
          .filter(Boolean)
      );
      const split = current.reduce(
        (acc, item) => {
          const key = item && (item.id || item.photoId);
          if (key && lastIds.has(key)) acc.old.push(item);
          else acc.new.push(item);
          return acc;
        },
        { old: [], new: [] }
      );

      return split.new.length > 0 ? split.new : current;
    },
    showUploadControls() {
      if (this.readOnlyInputs) return false;
      // [Modified by E2logy]: a photo waiting on the device counts as taken, so
      // the empty camera box is not shown next to its preview.
      if (this.queuedPhotoEntries.length > 0) {
        return this.question?.isFromLastResponse === true;
      }
      const visible = this.visibleAttachments;
      if (!visible || visible.length === 0) return true;
      return this.question?.isFromLastResponse === true;
    },
    worksessionSurveyPhotosPortal() {
      let ret = null;
      if (this.question && this.question?.worksession_survey_photos_portal) {
        ret = this.question.worksession_survey_photos_portal;
      }
      return ret;
    },
    isHiddenForBrandPhotosPortal() {
      let ret = null;
      if (this.worksessionSurveyPhotosPortal) {
        const { isHiddenForBrand } = this.worksessionSurveyPhotosPortal;
        ret = isHiddenForBrand;
      }
      return ret;
    },
    isWarningPhotosPortal() {
      let ret = null;
      if (this.worksessionSurveyPhotosPortal) {
        const { isWarning } = this.worksessionSurveyPhotosPortal;
        ret = isWarning;
      } else {
        if (
          this.question?.foundLastResponseSurveyQuestionItem &&
          this.question?.foundLastResponseSurveyQuestionItem
            ?.worksession_survey_photos_portal
        ) {
          const {
            isWarning
          } = this.question?.foundLastResponseSurveyQuestionItem?.worksession_survey_photos_portal;
          ret = isWarning;
        }
      }
      return ret;
    },
    commentsPhotosPortal() {
      let ret = [];
      if (this.worksessionSurveyPhotosPortal) {
        const {
          commentsAdmin,
          scoreAdminBy,
          isCommentsAdmin,
          ppScoreAdminBy,
          commentsBrand,
          scoreBrandBy,
          isCommentsBrand,
          ppScoreBrandBy,
          commentsGPV,
          scoreGPVBy,
          isCommentsGPV,
          ppScoreGPVBy
        } = this.worksessionSurveyPhotosPortal;
        if (ppScoreAdminBy && commentsAdmin !== null) {
          ret.push({
            label: "Admin",
            text: commentsAdmin
          });
        }
        if (ppScoreBrandBy && commentsBrand !== null) {
          ret.push({
            label: "Marca",
            text: commentsBrand
          });
        }
        if (ppScoreGPVBy && commentsGPV !== null) {
          ret.push({
            label: "GPV",
            text: commentsGPV
          });
        }
      }
      return ret;
    },
    punctuationLabel() {
      let str = ``;
      if (this.punctuationValue !== null) {
        return `Punctuation: ${this.punctuationValue} / 5`;
      }
      return str;
    },
    punctuationValue() {
      let ret = null;
      if (this.worksessionSurveyPhotosPortal) {
        const {
          scoreGPV,
          scoreGPVBy,
          ppScoreGPVBy,
          scoreBrand,
          scoreBrandBy,
          ppScoreBrandBy,
          scoreAdmin,
          scoreAdminBy,
          ppScoreAdminBy
        } = this.worksessionSurveyPhotosPortal;
        if (ppScoreBrandBy && scoreBrand !== null && !isNaN(scoreBrand)) {
          return scoreBrand;
        } else if (
          ppScoreAdminBy &&
          scoreAdmin !== null &&
          !isNaN(scoreAdmin)
        ) {
          return scoreAdmin;
        } else if (ppScoreGPVBy && scoreGPV !== null && !isNaN(scoreGPV)) {
          return scoreGPV;
        }
      }
      return ret;
    },
    currentProOrMatId() {
      let proOrMatId = null;
      if (this.proOrMat && this.proOrMat?.id) proOrMatId = this.proOrMat?.id;
      return proOrMatId;
    },
    buttonText() {
      return this.isSelecting ? "Uploading..." : this.defaultButtonText;
    },
    uploadedMainImage() {
      if (this.visibleAttachments && this.visibleAttachments.length > 0) {
        const firstImageItem = this.visibleAttachments[0];
        return firstImageItem;
      }
      return null;
    },
    thumbnailMainImage() {
      const image = this.uploadedMainImage;
      if (image && image?.worksessionSurveyResponsePhoto) {
        return ApiService.getImageOrFileGlobalUri(
          image.worksessionSurveyResponsePhoto
        );
      } else if (image) {
        const localUrl = getCachedObjectUrl(image);
        if (localUrl) return localUrl;
      }
      // [Added by E2logy]: fall back to the photo still held in the queue.
      return this.pendingPreviewUrl;
    },
    isShowCamera() {
      let ret = false;
      const isSelectedCamera = ["BOTH", "CAMERA"].includes(this.photoType);
      const isShowOnThisDevice =
        this.deviceInformation &&
        ["PC", "TABLET"].includes(this.deviceInformation?.type);

      return (ret = isSelectedCamera);
    },
    isShowGallery() {
      let ret = false;
      const isSelectedGallery = ["BOTH", "GALLERY"].includes(this.photoType);
      return (ret = isSelectedGallery);
    }
  },
  methods: {
    // [Added by E2logy]: retry only the queued photos of this question
    onClickRetryUpload() {
      const entries = this.queuedPhotoEntries || [];
      entries
        .filter(el => el.status === "failed")
        .forEach(el => PhotoQueueService.retry(el.uuid));
    },
    onImageError(event) {
      event.target.src = require("@/assets/missing.png");
      event.target.alt = "Imagen no encontrada";
    },
    onClickSaveComments(saveData) {
      this.$emit("onClickSaveComments", saveData);
    },
    deleteAttachment(delId) {
      this.$emit("deleteAttachmentItem", delId);
    },
    async onClickThumbnail(currentProOrMatId, questionId, options = {}) {
      console.log(
        "currentProOrMatId, questionId - ",
        currentProOrMatId,
        questionId
      );
      this.$refs[
        `dialogPhotoDetail_${currentProOrMatId}_${questionId}`
      ].showModal(this.question, this.attachments, options);
      if (this.worksessionSurveyPhotosPortal) {
        const { id, isWarning } = this.worksessionSurveyPhotosPortal;
        if (isWarning) {
          // request for set isWarning to 0
          let form_data = {
            isWarning: 0,
            id
          };
          const { data } = await ApiService.post(
            `worksession/survey/update_photos_portal`,
            form_data
          );
          this.$emit("updatePhotosPortalAttributes", { isWarning: 0 });
        }
      }
    },
    getThumbnailUri(image) {
      return ApiService.getThumbnailUri(image);
    },
    onUploadAttachment() {
      // this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: false }
      );
      this.$refs.uploaderPhotos.click();
    },
    openCameraAttachment() {
      const refKey = `surveyPhotoInstance_${this.currentProOrMatId}_${this.question.id}`;
      if (this.$refs[refKey] && typeof this.$refs[refKey].onClick === "function") {
        this.$refs[refKey].onClick();
      }
    },
    onClickUploadAttachment(source) {
      if (source === "camera") {
        this.openCameraAttachment();
        return;
      }
      if (source === "gallery") {
        this.onUploadAttachment();
        return;
      }
      if (this.photoType === "CAMERA") {
        this.openCameraAttachment();
      } else {
        this.onUploadAttachment();
      }
    },
    async onFileChanged(e) {
      this.selectedFile = e.target.files;
      if (this.selectedFile.length > 0) {
        // [Added by E2logy]: a file that is not a real photo is never saved on
        // the device. The input is cleared so another file can be picked.
        if (!(await isRealImageFile(this.selectedFile[0]))) {
          logError(this.$t("photo_invalid_file"));
          e.target.value = "";
          return;
        }
        this.newAttachedPhotos = [];
        this.newAttachedPhotos.push(this.selectedFile[0]);
        this.$emit("input", this.newAttachedPhotos);
        this.openDialogAfterCapture();
      }
    },
    // [Added by E2logy]: opens the rating dialog once, right after the surveyor
    // took a photo. It does nothing when the dialog is already open, which is the
    // case for the "añadir foto" button inside the dialog.
    openDialogAfterCapture() {
      const dialog = this.$refs[
        `dialogPhotoDetail_${this.currentProOrMatId}_${this.question.id}`
      ];
      if (!dialog) return;
      if (typeof dialog.isOpen === "function" && dialog.isOpen()) return;
      this.$nextTick(() => {
        this.onClickThumbnail(this.currentProOrMatId, this.question.id, {
          afterCapture: true
        });
      });
    },
    async detectedLocation() {
      let photoTaken = await this.$refs.webCameraInstance.getTakenPhotoFile();
      if (photoTaken) {
        this.newAttachedPhotos = [];
        this.newAttachedPhotos.push(photoTaken);
        this.$emit("input", this.newAttachedPhotos);
      }
    },
    async onPictureSurveyPhoto() {
      const pictureInput = this.$refs[
        `surveyPhotoInstance_${this.currentProOrMatId}_${this.question.id}`
      ];
      const photoTaken = pictureInput.file;
      if (photoTaken) {
        // [Added by E2logy]: same check as for a gallery photo. The picture
        // input already switched to its preview, so it is put back to empty
        // and shows "Selecciona una foto" again instead of a blank thumbnail.
        if (!(await isRealImageFile(photoTaken))) {
          logError(this.$t("photo_invalid_file"));
          pictureInput.removeImage();
          return;
        }
        this.newAttachedPhotos = [];
        this.newAttachedPhotos.push(photoTaken);
        this.$emit("input", this.newAttachedPhotos);
        this.openDialogAfterCapture();
      }
    }
  }
};
</script>

<style>
.questionbox .web-camera-container {
  margin-top: 0rem !important;
  margin-bottom: 0rem !important;
  padding: 0rem !important;
}
.questionbox .btn_select_images {
  width: 100%;
}
.questionbox .photo-webcamera {
  width: 100%;
  height: auto;
  aspect-ratio: 1/1;
}
.questionbox .photo .thumbnail_image {
  max-width: 100%;
  max-height: 150px;
  cursor: pointer;
}
</style>
